import React from 'react';

import { useSnackbar } from '@/modules/core/hooks';

import SnackbarBlock from './SnackbarBlock';
import SnackbarItem from './SnackbarItem';

const Snackbar = () => {
  const { snackbars } = useSnackbar();
  const rootNode = document.getElementById('root');
  const { handleRemoveSnackbarById } = useSnackbar();
  if (rootNode) {
    return (
      <>
        {snackbars.map((item) => (
          <SnackbarBlock key={item.id} notification={item.closeIcon} zIndex={item.zIndex}>
            <SnackbarItem
              options={item}
              onClose={handleRemoveSnackbarById}
            />
          </SnackbarBlock>
        ))}
      </>
    );
  }
  return null;
};
export default Snackbar;
